// extracted by mini-css-extract-plugin
export default {"container":"SignupForm_container__kRGQg","label":"SignupForm_label__Xk-ov","button":"SignupForm_button__zhHMm","inputContainer":"SignupForm_inputContainer__JFdKf"};